import { Header } from "../components";

const ColorCard = ({
  label,
  hex,
  bgColor,
  textColor,
  classNames = "",
}: {
  label?: string;
  hex?: string;
  bgColor: string;
  textColor?: string;
  classNames?: string;
}) => (
  <div className="color-card">
    <div
      className={`color-box ${classNames}`}
      style={{ background: `var(${bgColor})`, color: textColor || "inherit" }}
    >
      {label && <span>{label}</span>}
    </div>
    <p className="color-meta">
      {bgColor}
      {hex && (
        <>
          <br />
          {hex}
        </>
      )}
    </p>
  </div>
);

const TextRow = ({
  bgColor,
  textColor,
}: {
  bgColor: string;
  textColor: string;
}) => (
  <div
    className="text-row"
    style={{ background: `var(${bgColor})`, color: textColor }}
  >
    {bgColor}
  </div>
);

export const ColorStyleGuide = () => (
  <>
    <Header title="CLX Colors" />

    <div className="color-guide-page">
      <div className="color-guide-top-row">
        <section className="color-guide-section">
          <h2>Background Colors</h2>
          <div className="color-grid">
            <ColorCard
              label="Background Light"
              bgColor="--clx-savvy-white"
              hex="#F5FAFF"
              textColor="#111731"
            />
            <ColorCard
              label="Background Dark"
              bgColor="--clx-savvy-black"
              hex="#111731"
              textColor="#FFF"
            />
          </div>
        </section>

        <section className="color-guide-section">
          <h2>Text Colors</h2>
          <div className="color-guide-text-column">
            <TextRow bgColor="--clx-savvy-white" textColor="#111731" />
            <TextRow bgColor="--clx-savvy-300" textColor="#0D006D" />
            <TextRow bgColor="--clx-savvy-500" textColor="#FFF" />
            <TextRow bgColor="--clx-savvy-accent" textColor="#FFF" />
            <TextRow bgColor="--clx-savvy-900" textColor="#FFF" />
          </div>
        </section>
      </div>

      <section>
        <h2>Primary Color scheme</h2>
        <div className="color-grid boxes-7">
          <ColorCard bgColor="--clx-savvy-white" hex="#F5FAFF" />
          <ColorCard bgColor="--clx-savvy-accent" hex="#8D007C" />
          <ColorCard bgColor="--clx-savvy-300" hex="#8390FA" />
          <ColorCard bgColor="--clx-savvy-500" hex="#5900DC" />
          <ColorCard bgColor="--clx-savvy-700" hex="#270097" />
          <ColorCard bgColor="--clx-savvy-900" hex="#0D006D" />
          <ColorCard bgColor="--clx-savvy-black" hex="#111731" />
        </div>
      </section>

      <section>
        <h2>Gradients</h2>
        <div className="color-grid boxes-3">
          <ColorCard
            label="Gradient Light"
            bgColor="--clx-savvy-light-gradient"
            textColor="#111731"
          />
          <ColorCard
            label="Gradient Medium"
            bgColor="--clx-savvy-medium-gradient"
            textColor="#FFF"
          />
          <ColorCard
            label="Gradient Dark"
            bgColor="--clx-savvy-dark-gradient"
            textColor="#FFF"
          />
        </div>
      </section>

      <section>
        <h2>Value Color scheme</h2>
        <div className="color-grid boxes-6">
          <ColorCard bgColor="--clx-blue-100" hex="#ADC6FF" />
          <ColorCard bgColor="--clx-blue-300" hex="#85A5FF" />
          <ColorCard bgColor="--clx-blue-500" hex="#597EF7" />
          <ColorCard bgColor="--clx-blue-700" hex="#2F54EB" />
          <ColorCard bgColor="--clx-blue-800" hex="#1D39C4" />
          <ColorCard bgColor="--clx-blue-900" hex="#061178" />
        </div>
      </section>

      <section>
        <h2>Secondary Colors</h2>
        <div className="color-grid secondary-boxes">
          <ColorCard bgColor="--clx-error-200" hex="#FECDCA" />
          <ColorCard bgColor="--clx-error-400" hex="#F97066" />
          <ColorCard bgColor="--clx-error-600" hex="#D82C27" />
          <div className="spacer"></div>
          <ColorCard bgColor="--clx-success-100" hex="#D1FADF" />
          <ColorCard bgColor="--clx-success-300" hex="#82CDB0" />
          <ColorCard bgColor="--clx-success-500" hex="#18CF8F" />
          <div className="break"></div>
          <ColorCard bgColor="--clx-warning-100" hex="#FEF0C7" />
          <ColorCard bgColor="--clx-warning-300" hex="#FEC84B" />
          <ColorCard bgColor="--clx-warning-500" hex="#F79009" />
        </div>
      </section>
    </div>
  </>
);
